import { useCallback } from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';

import type { CreateTokenError, DLocalValidationError } from 'src/app/shared/components/payments';

/**
 * @docs https://docs.dlocal.com/reference/the-fields-object
 */
export function useMapDlocalValidationError(): (dlocalError: CreateTokenError) => {
	field: keyof DLocalValidationError;
	message: string;
} {
	const { translate } = useI18n();

	return useCallback(
		(
			dlocalError: CreateTokenError,
		): {
			field: keyof DLocalValidationError;
			message: string;
		} => {
			const { param, message: errorMessage } = dlocalError.error || {};

			// Map DLocal SDK param values to our error field names
			const errorFieldMap: Record<string, keyof DLocalValidationError> = {
				expiration: 'expire',
				cvv: 'cvv',
				cvc: 'cvv',
				pan: 'card',
				card: 'card',
			};

			// TODO: Add controlled translations for the error message
			const errorField = errorFieldMap[param?.toLowerCase() ?? ''] ?? 'card';
			const defaultMessage = translate('fe.errors.credit_card.number');

			return {
				field: errorField,
				message: errorField === 'card' ? defaultMessage : (errorMessage ?? defaultMessage),
			};
		},
		[translate],
	);
}
